var login = {
  translation: {
    common: {
      accept: 'Qabul qilish',
      alreadyUser: 'Allaqachon foydalanuvchimisiz?',
      and: 'va',
      backToLogin: 'Kirish sahifasiga qaytish',
      continueWith: '{{provider}} bilan davom etish',
      createAccount: 'Hisob yaratish',
      createYourAccount: 'Hisobingizni yarating',
      emailOrUsername: 'Email yoki foydalanuvchi nomi',
      login: 'Kirish',
      logIn: 'Kirish',
      logInToBoards: 'Kirish',
      newToBoards: '4ga Boardsda yangimisiz?',
      pageNotFound_title: 'Sahifa topilmadi',
      password: 'Parol',
      privacyPolicy: 'Maxfiylik siyosati',
      register: "Ro'yxatdan o'tish",
      registerWithGoogle: "Google orqali ro'yxatdan o'tish",
      termsOfService: 'Xizmat shartlari',
      togglePasswordVisibility: "Parolni ko'rsatish/yashirish",
    },
  },
};

export { login as default };
